import { axios } from "../lib/axios";

export const getTreatmentType = async function (treatmentTypeId) {
  try {
    const response = await axios.get("settings/gettreatmenttype", {
      params: { treatmentTypeId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getTreatmentTypes = async function () {
  try {
    const response = await axios.get("settings/getalltreatmenttypes");
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const addTreatmentType = async function (model) {
  try {
    const response = await axios.post("settings/addtreatmenttype", model);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateMildCasePackage = async function (model) {
  try {
    const response = await axios.put("settings/updatemildcasepackage", model);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateComplexCasePackage = async function (model) {
  try {
    const response = await axios.put(
      "settings/updatecomplexcasepackage",
      model
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteTreatmentType = async function (model) {
  try {
    const response = await axios.delete("settings/deletetreatmenttype", {
      data: model,
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
